import { useState, useEffect } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';

const AdminAnnouncement = () => {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        checkAdminStatus();
    }, []);

    const checkAdminStatus = () => {
        const isAdminStored = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdminStored);

        if (!isAdminStored) {
            setErrorMessage('Unauthorized: You do not have permission to create an announcement.');
            console.error('Unauthorized access: User is not an admin');
        }
    };
const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isAdmin) {
        alert('Unauthorized: You do not have permission to post announcements.');
        return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
        alert('Authentication error: No token found.');
        return;
    }

    // Ensure the title and message are UTF-8 encoded before sending

    const payload = {
        title: title,
        message: message
    };

    try {
        const response = await axios.post('https://hbmdijital.online/api/admin/announcement', 
        payload, 
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        alert('Announcement posted successfully!');
        setTitle('');
        setMessage('');
    } catch (error) {
        console.error('Error posting announcement:', error.response?.data || error.message);
        alert('Error posting announcement.');
    }
};

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div>
                {errorMessage ? (
                    <div style={{
                        backgroundColor: '#ff4d4d',
                        color: 'white',
                        padding: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold'
                    }}>
                        {errorMessage}
                    </div>
                ) : (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="container w-100 w-md-75 p-3"> {/* Increased width and added padding */}
                            <div className="card shadow-lg"> {/* Added shadow for a better visual on mobile */}
                                <div className="card-header text-center fs-4">Créer un actualité</div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="small mb-1" htmlFor="name">Titre</label>
                                            <input 
                                                className="form-control form-control-lg"  // Increased input size for better usability
                                                id="name" 
                                                type="text" 
                                                value={title} 
                                                onChange={(e) => setTitle(e.target.value)}
                                                placeholder="titre d'annonce" 
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="small mb-1" htmlFor="message">Message</label>
                                            <textarea
                                                id="message"
                                                className="form-control form-control-lg"  // Ensure styling consistency
                                                placeholder="Message"
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <button 
                                            className="btn btn-lg w-100" 
                                            style={{ backgroundColor: '#1e3d56', color: 'white', border: 'none' }}
                                            type="submit"
                                        >
Publier </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </AnimationRevealPage>
    );
};

export default AdminAnnouncement;